<template>
  <section class="Cooperative">
    <img src="../../assets/images/topline.png" class="topline" />
    <img src="../../assets/images/Cooperative unit.png" class="imgtitle" />
    <div class="cooperative-div">
      <img
        src="../../assets/images/mapMap.png"
        style="z-index: 1"
        class="cooperative-img1"
        :class="animateClass1"
      />
      <img
        src="../../assets/images/mapPoint.png"
        style="z-index: 3"
        class="cooperative-img2"
        :class="animateClass2"
      />
      <img
        src="../../assets/images/mapLine.png"
        style="z-index: 2"
        class="cooperative-img3"
        :class="animateClass3"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUs',
  mounted () {
    window.addEventListener('scroll', this.btn_pos);
  },
  data () {
    return {
      animateClass1: "",
      animateClass2: "displaynone",
      animateClass3: "displaynone",
      aniSHOW: false,
    }
  },
  methods: {
    btn_pos: function () {

      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;//滚动条的高度
      var clientHeight = document.documentElement.clientHeight; //可视区的高度
      // console.log(scrollTop, clientHeight)
      //滚动条的高度>可视区的高度
      if (scrollTop > 3100 && this.aniSHOW == false) {
        this.aniSHOW = true
        // this.animateClass1 = "animated1 animated fadeIn"
        this.animateClass2 = "animated2 animated fadeIn"
        this.animateClass3 = "animated3 animated fadeIn"
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../assets/style/ani.css";
.yourElement {
  --animate-duration: 10ms !important;
  --animate-delay: 5ms;
}
.animated1 {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated2 {
  -webkit-animation-duration: 3s;
  animation-duration: 3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated3 {
  -webkit-animation-duration: 5s;
  animation-duration: 5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.imgtitle {
  width: 626px;
  height: 80px;
  margin-bottom: 10px;
}
.Cooperative {
  margin: 40px 0;
}
.cooperative-div {
  width: 1180px;
  height: 600px;
  position: relative;
}
.cooperative-img1 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 600px;
}
.cooperative-img2 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 600px;
}
.cooperative-img3 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 600px;
}
.displaynone {
  display: none;
}
.topline {
  width: 1px;
  height: 100px;
  margin: 0 auto;
  margin-bottom: 30px;
}
</style>
